import { useQuery } from "@tanstack/react-query";

/**
 * Discoverability for the unsubscribe-scope decision: email_suppression
 * blocks EVERY campaign type, not just the newsletter, so a buyer contact who
 * unsubscribed goes silent on teasers and CIMs with nothing else in the CRM
 * to explain why. This surfaces that on the buyer's own page. staleTime is
 * generous (this rarely changes and it's one query per visible contact).
 */
export function SuppressionBadge({ email }: { email: string | null }) {
  const { data } = useQuery<{ suppressed: boolean; unsubscribedAt: string | null; issueName: string | null }>({
    queryKey: ["/api/newsletter/suppression", email],
    queryFn: () => fetch(`/api/newsletter/suppression/${encodeURIComponent(email!)}`, { credentials: "include" }).then((r) => r.json()),
    enabled: !!email,
    staleTime: 5 * 60 * 1000,
  });
  if (!data?.suppressed) return null;
  return (
    <span
      className="rounded px-1 text-[10px] font-medium uppercase tracking-wide bg-amber-500/15 text-amber-700 dark:text-amber-400"
      title={
        data.unsubscribedAt
          ? `Unsubscribed ${data.unsubscribedAt}${data.issueName ? ` from ${data.issueName}` : ""}. Receives no campaign email of any type.`
          : "Suppressed. Receives no campaign email of any type."
      }
    >
      Suppressed
    </span>
  );
}
